import { Table } from "@/features/Table";
import { type C8TimeSerie, columns } from "./columns";
import { type FilterC8TimeSeriesSchema, FilterC8TimeSeries } from "./filter";

const client = "c8";
const table_name = "c8_time_series";

export const C8TimeSeriesTable = () => {
  return (
    <Table<C8TimeSerie, FilterC8TimeSeriesSchema>
      label="Valorisation"
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterC8TimeSeries />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
